import * as React from 'react';
import { ArticleParagraph1 } from '@cian/ui-kit';

interface ICounterProps {
  text: string;
}

export const Counter: React.FC<ICounterProps> = ({ text }) => {
  return (
    <ArticleParagraph1 fontWeight="bold" display="block" data-testid="Counter">
      {text}
    </ArticleParagraph1>
  );
};
